<template>
    <div class=" my">
        <nav-bar :title="$store.state.activityName+'活动车辆'"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" class="my-nav" />
        <div style="height: 3rem"></div>
        <!-- 上滑进入 -->
        <cell-group :title="list.length?'活动车辆':'目前活动还没有可拼车辆，请稍后到（我的报名）中，查看相应活动的车辆'">
            <span></span>
            <collapse v-model="activeNames">
                <div v-for="(v,i) in list" :key="i">
                    <collapse-item :title="v.vehicleName +' '+ v.appUser.userName"
                                   :label="'出发地点：'+v.departure"
                                   :icon="v.appUser.openid == openid?'manager':'hot'"
                                   :name="i">
                        <ant-row>
                            <ant-col span="8">
                                <div>联系方式:</div>
                                <div>共有座位:</div>
                                <div>剩余座位:</div>
                                <div>出发地点:</div>
                                <div>出发时间:</div>
                            </ant-col>
                            <ant-col span="11">
                                <div>{{v.phone}}</div>
                                <div>{{v.seatNumber}}</div>
                                <div>{{v.surplusSite}} <span v-if="v.surplusSite==0" style="color:#ff0000">座位已满</span>
                                </div>
                                <div>{{v.departure}}</div>
                                <div>{{v.endTime}}</div>
                            </ant-col>
                        </ant-row>
                        <ant-row>
                            <ant-col span="8">
                                <div>备注:</div>
                            </ant-col>
                            <ant-col span="16">
                                <div>{{v.remark}}</div>
                            </ant-col>
                        </ant-row>
                        <ant-row type="flex" justify="end" v-if="v.appUser.openid != openid">
                            <ant-button type="danger" round block style="margin-top: 10px"
                                        :disabled=" v.surplusSite == 0 "
                                        @click="myToCar(v)">
                                我要拼车
                            </ant-button>
                        </ant-row>
                    </collapse-item>
                </div>
            </collapse>
        </cell-group>

        <cell-group title="您是否愿意搭载其他同事一同前往，如果愿意请填写以下信息。如果不方便，请直接点击左上角返回">
            <ant-form validate-first @submit="onSubmit">
                <ant-field label="车牌号：" v-model="form.vehicleName" required
                           :rules="[{ required: true , message: '请填写车牌号' }]"
                           placeholder="请输入内容"/>
                <ant-field label="联系方式："
                           v-model="form.phone"
                           required type="tel"
                           placeholder="请输入联系方式"
                           :rules="[{ required: true, message: '请填写手机号' }]"/>
                <ant-field label="剩余座位："
                           v-model="form.seatNumber"
                           required type="number"
                           placeholder="请输入剩余座位"
                           :rules="[{ required: true, message: '请填写剩余座位' }]"/>
                <ant-field label="出发地点："
                           v-model="form.departure"
                           required
                           placeholder="请输入出发地点"
                           :rules="[{ required: true, message: '请填写出发地点' }]"/>
                <!--                <ant-field v-model="form.startTime" ref="startTime"-->
                <!--                           label="准备时间：" placeholder="请输入开始时间" @click="openStartTime(0)"/>-->
                <ant-field v-model="form.endTime" ref="endTime"
                           label="出发时间：" placeholder="请输入结束时间" @click="openStartTime(1)"
                           :rules="[{ required: true, message: '请输入结束时间' }]"/>
                <ant-field label="备注："
                           v-model="form.remark"
                           rows="2"
                           autosize
                           type="textarea"
                           maxlength="50"
                           placeholder="请输入内容"
                           s0000how-word-limit/>
                <div style="margin: 16px;">
                    <ant-button round block type="danger" native-type="submit" :loading="loading">
                        保存我的车辆信息
                    </ant-button>
                </div>
            </ant-form>
        </cell-group>
        <popup v-model="show" round position="bottom" :style="{ height: '40%' }">
            <datetime-picker
                    v-model="currentTime"
                    type="time"
                    title="选择时间"
                    :min-hour="0"
                    :max-hour="24"
                    @confirm="confirm"
                    @cancel="cancel"/>
        </popup>
    </div>
</template>

<script>
    import service from "../../api/service";
    import {
        Cell, CellGroup, NavBar, Divider,
        Button, Form, Field, DatetimePicker,
        Popup, Toast, Collapse, CollapseItem,
        Col, Row
    } from 'vant'
    //活动车辆
    export default {
        name: "carList",
        components: {
            Cell, CellGroup,
            NavBar, Divider,
            AntButton: Button,
            AntForm: Form,
            AntField: Field, DatetimePicker, Popup,
            Collapse, CollapseItem, AntCol: Col, AntRow: Row
        },
        data() {
            return {
                loading: false,
                openid: sessionStorage.getItem("openid"),
                list: [],
                listB: [],
                activeNames: [],
                currentTime: '',
                show: false,
                attendstatue: false,
                position: 0,
                form: {
                    vehicleName: '',
                    seatNumber: 4,
                    belongs: sessionStorage.getItem("openid"),
                    activityId: sessionStorage.getItem("proId"),
                    startTime: '',
                    endTime: '',
                    remark: '',
                    departure: ''
                },
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                //活动茶凉
                service.get('/api/vehicle', {
                    activityId: sessionStorage.getItem("proId"),
                    belongs: sessionStorage.getItem("openid")
                }).then(res => {
                    if (res.status === 200) {
                        this.list = res.data
                    }
                })
                service.get('/api/activity-creation-approval/myVehicleInformation', {
                    openid: sessionStorage.getItem("openid")
                }).then(res => {
                    if (res.status === 200 && res.data.length > 0) {
                        let d = res.data[0]
                        this.form.vehicleName = d.vehicleName
                        this.form.phone = d.phone
                        this.form.seatNumber = d.seatNumber
                        this.form.departure = d.departure
                    }
                })

            },
            //返回
            onClickLeft() {
                this.$router.push({path: '/personalCenter'})
            },
            //分享车位
            onSubmit() {
                let form = {...this.form}
                form.activityName = sessionStorage.getItem("activityName")
                this.loading = true
                if (form.id) {
                    service.put('/api/vehicle', form).then(res => {
                        this.loading = false
                        if (res.status === 200) {
                            Toast.success("提交成功")
                            this.init()
                        } else {
                            Toast.fail("提交失败")
                        }
                    })
                } else {
                    service.post('/api/vehicle', form).then(res => {
                        this.loading = false
                        if (res.status === 200) {
                            Toast.success("提交成功")
                            this.init()
                        } else {
                            Toast.fail("提交失败")
                        }
                    })
                }

            },
            openStartTime(v) {
                this.position = v
                this.show = true
                this.$refs.startTime.blur()
                this.$refs.endTime.blur()
            },
            //确认
            confirm(v) {
                if (this.position === 0) {
                    this.form.startTime = v
                } else {
                    this.form.endTime = v
                }
                this.show = false
            },
            //关闭
            cancel() {
                this.show = false
            },
            //我要拼车
            myToCar(v) {
                service.post('/api/VehicleUser/userlift', {
                    openid: sessionStorage.getItem("openid"),
                    vehicleId: v.id,
                }).then(res => {
                    if (res.status === 200) {
                        Toast.success("报名成功")
                        this.init()
                    } else {
                        Toast.fail(res.message)
                    }
                })
            }

        }
    }
</script>

<style scoped>
    .my {
        background-color: #f7f8fa;
        min-height: 100vh;
    }
</style>